import { motion } from "framer-motion";
import RoomsSection from "../components/RoomsSection";
import AmenitiesSection from "../components/AmenitiesSection";
import GallerySection from "../components/GallerySection";
import ContactSection from "../components/ContactSection";
import SectionDivider from "../components/SectionDivider";

export default function Home() {
    return (
        <>
            {/* Hero Section */}
            <section
                className="h-screen bg-cover bg-center relative"
                style={{ backgroundImage: "url('/assets/images/hero.jpg')" }}
            >

                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>

                {/* Centered Content */}
                <div className="relative h-full flex items-center justify-center text-center px-6">

                    <div className="max-w-3xl">

                        {/* Tagline */}
                        <motion.p
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8 }}
                            className="text-sm tracking-[0.3em] text-ivory/70 uppercase"
                        >
                            Welcome to
                        </motion.p>

                        {/* Main Title */}
                        <motion.h1
                            initial={{ opacity: 0, y: 40 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1 }}
                            className="mt-4 text-5xl md:text-7xl font-serif text-gold leading-tight"
                        >
                            M R Suites Dharwad
                        </motion.h1>

                        {/* Divider */}
                        <div className="flex justify-center my-6">
                            <div className="w-20 h-[1px] bg-gold"></div>
                        </div>

                        {/* Description */}
                        <motion.p
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1.2 }}
                            className="text-lg md:text-xl text-ivory/90 leading-relaxed"
                        >
                            A refined stay where heritage elegance meets modern comfort.
                        </motion.p>

                        {/* CTA */}
                        <motion.a
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1.4 }}
                            href="https://wa.me/917090628555"
                            target="_blank"
                            rel="noreferrer"
                            className="inline-block mt-10 bg-gold text-charcoal px-10 py-3 rounded-full tracking-wide hover:scale-105 hover:shadow-xl transition"
                        >
                            Enquire on WhatsApp
                        </motion.a>

                    </div>
                </div>
            </section>

            {/* Sections */}
            <RoomsSection />
            <AmenitiesSection />
            <GallerySection />
            <ContactSection />
        </>
    );
}